module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0AgMAAAC4FvN4AAAAAXNSR0IArs4c6QAAAAxQTFRFAAAAfn6BfoCBfX6ATzVsEwAAAAN0Uk5TAH+Av2kixwAAADFJREFUKM9jYCAacCEBBgZ+JIDOQ1VJHcD/HwE+0IFHHcAaigABeO1DVTmSw4wq6QwAK1nj0cN7I1wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/assets/images/divider-icon.png
// module id = qu2d
// module chunks = 243